import { render, staticRenderFns } from "./MessageAudio.vue?vue&type=template&id=35fefea0&scoped=true&"
import script from "./message-audio.ts?vue&type=script&lang=ts&"
export * from "./message-audio.ts?vue&type=script&lang=ts&"
import style0 from "./MessageAudio.vue?vue&type=style&index=0&id=35fefea0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fefea0",
  null
  
)

export default component.exports